<div class="card-container mat-elevation-z1">
    <div class="card-content">
        <form [formGroup]="form">
            <div *ngIf="!loading">
                <div class="full-width margin-right-small">
                    <h4>Configuración</h4>
                    <mat-divider></mat-divider>
                    <div class="margin-top-medium">
                        <table mat-table class="medium-width margin-botton-medium" *ngIf="medicalAppointmentCareStudyDeliveries.controls.length > 0" [dataSource]="dataSource" formArrayName="MedicalAppointmentCareStudyDeliveries">
                            <tr mat-header-row class="table-header" *matHeaderRowDef="displayColumns"></tr>
                            <tr mat-row class="table-cell" *matRowDef="let row; let i = index; columns: displayColumns;"></tr>



                            <ng-container matColumnDef="Region">
                                <th mat-header-cell class="table-header" *matHeaderCellDef> Subesp. </th>
                                <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                                    <mat-form-field class="card-inline  margin-right-small">
                                        <mat-select formControlName="StudyRegion">
                                            <mat-option *ngFor="let studyRegion of studyRegions" [value]="studyRegion">
                                                {{ studyRegion.Name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="StudyDeliverDate">
                                <th mat-header-cell class="table-header" *matHeaderCellDef> Fecha entrega </th>
                                <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                                    <mat-form-field class="card-inline  margin-right-small">
                                        <input matInput formControlName="StudyDeliverDate" #dateOrder [matDatepicker]="picker">
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="ReportPhysician">
                                <th mat-header-cell class="table-header" *matHeaderCellDef> Informante </th>
                                <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                                    <mat-form-field class="card-inline  margin-right-small">
                                        <mat-select formControlName="ReportPhysician">
                                            <mat-option *ngFor="let physicianFilter of physicianFilters" [value]="physicianFilter">
                                                {{ physicianFilter.Name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="LogisticsComment">
                                <th mat-header-cell class="table-header" *matHeaderCellDef> </th>
                                <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">

                                    <button mat-button (click)="openLogisticsCommnetEdit(index)">Comentarios Servicio/Logística</button>

                                </td>
                            </ng-container>
                        </table>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>